/**
 * 模块名称: 考勤统计修改记录抽屉
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import { Drawer, Table, Button } from 'antd'
import api from 'api'

const { Column } = Table

const StatisticsRecordDrawer = (props) => {
  const { visible, onClose, record } = props
  const [loading, setLoading] = useState(false)
  const [recordList, setRecordList] = useState([])

  useEffect(() => {
    if (visible && record) {
      fetchRecordData()
    }
  }, [visible, record])

  const fetchRecordData = () => {
    setLoading(true)
    api.getCheckInStatModifyList({ id: record.id }).then(res => {
      setRecordList(res.list || [])
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }

  return (
    <Drawer
      title="考勤修改记录"
      width={850}
      onClose={onClose}
      visible={visible}
      destroyOnClose={true}
    >
      <div className="statistics-drawer-container">
        {record && (
          <div className="statistics-drawer-info">
            <div className="info-item">
              <span className="label">公司用名:</span>
              <span className="value">{record.userName || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">考勤月份:</span>
              <span className="value">{record.month || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">直属上级:</span>
              <span className="value">{record.lead || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">员工编号:</span>
              <span className="value">{record.no || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">所属公司:</span>
              <span className="value">{record.cropName || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">所属部门:</span>
              <span className="value">{record.sectionName || '--'}</span>
            </div>
          </div>
        )}

        <Table
          rowKey="id"
          dataSource={recordList}
          loading={loading}
          pagination={false}
        >
          <Column title="修改类型" dataIndex="typeName" align='center' width='12%' />
          <Column title={<>修改前<br />时长/次数</>} dataIndex="beforeData" align='center' width='12%' />
          <Column title={<>修改后<br />时长/次数</>} dataIndex="afterData" align='center' width='12%' />
          <Column title="修改时间" dataIndex="addTime" align='center' width='15%' />
          <Column
            title="上传附件"
            dataIndex="affix"
            width='22%'
            render={(text) => {
              try {
                const parsedData = text ? JSON.parse(text) : null
                return Array.isArray(parsedData)
                  ? parsedData.map((item, i) => (
                    <div style={{ marginTop: '10px' }} key={i}>
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.name}
                      </a>
                    </div>
                  ))
                  : '-'
              } catch (error) {
                return '-'
              }
            }}
          />
          <Column title="备注" dataIndex="remark" width='15%' />
          <Column title="修改人" dataIndex="modifyUser" align='center' width='12%' />
        </Table>
        <div style={{ position: 'absolute', bottom: 0, width: '100%', borderTop: '1px solid #e8e8e8', padding: '16px', textAlign: 'right', left: 0, background: '#fff' }}>
          <Button onClick={onClose}>
            关闭
          </Button>
        </div>
      </div>
    </Drawer>
  )
}

export default StatisticsRecordDrawer